import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchFitbitData,
  FitbitActivityData,
  FitbitSleepData,
  FitbitWaterData,
  FitbitRequestBody,
  FitbitResponseData,
} from "../../apis/fitbitApis";

interface FitbitState {
  activityData: FitbitActivityData | null;
  sleepData: FitbitSleepData[];
  waterData: FitbitWaterData[];
  loading: boolean;
  error: string | null;
}

const initialState: FitbitState = {
  activityData: null,
  sleepData: [],
  waterData: [],
  loading: false,
  error: null,
};

export const getFitbitData = createAsyncThunk<
  FitbitResponseData,
  FitbitRequestBody
>("fitbit/getFitbitData", async (body, { rejectWithValue }) => {
  try {
    const response = await fetchFitbitData(body);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || "Something went wrong");
  }
});

const fitbitSlice = createSlice({
  name: "fitbit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFitbitData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getFitbitData.fulfilled, (state, action) => {
        state.loading = false;
        state.activityData = action.payload.fitbitActivityData;
        state.sleepData = action.payload.fitbitSleepData;
        state.waterData = action.payload.fitbitWaterData;
      })

      .addCase(getFitbitData.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default fitbitSlice.reducer;
